import {
  DetailedProductFieldsFragment,
  ProductsByIdsQuery,
} from "client/graphql/storefront-api"

// Predicate to determine whether something returned by ProductsByIdsQuery is actually a product
// The query, for some reason, has a return type that includes a lot of non-product things.
export function isProduct(
  product: ProductsByIdsQuery["products"][0] | undefined,
): product is DetailedProductFieldsFragment {
  return product?.__typename === "Product"
}
